import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import faceCheckReducer from './features/faceCheck/faceCheckSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Usa localStorage por defecto

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    auth: persistedReducer,
    faceCheck: faceCheckReducer, // no persistido — se recalcula en cada login
  },
});

export const persistor = persistStore(store);
export default store;
